import * as React from "react";
import { SVGProps } from "react";
const SponsorStar = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={17}
        fill="none"
        {...props}
    >
        <path
            fill="#E2FF05"
            d="M10.435 5.681 8 1.016 5.565 5.68 1 8.169l4.565 2.488L8 15.323l2.435-4.666L15 8.17l-4.565-2.488Z"
        />
    </svg>
);
export default SponsorStar;
